function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M15.2,14c1,0.7,2.2,1.7,3.2,2.4l0,0L17.2,18c-1-0.7-2.2-1.7-3.2-2.4 C14.4,15.1,14.8,14.5,15.2,14z M11,4v12l-5-3H5v4H3v-4H2c-1.1,0-2-0.9-2-2l0,0V9c0-1.1,0.9-2,2-2l0,0h4L11,4z M12,6.6 c0.9,0.8,1.5,2,1.5,3.4s-0.6,2.5-1.5,3.3l0,0V6.6z M9,7.5L7,8.7L6.6,9H2v2h4.6L7,11.3l2,1.2V7.5z M20,9v2l0,0h-4l0,0V9l0,0H20L20,9z  M17.2,2c0.4,0.5,0.8,1.1,1.2,1.6c-1,0.7-2.2,1.7-3.2,2.4l0,0L14,4.4C15,3.7,16.2,2.7,17.2,2z"
});

var SvgManager = function SvgManager(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManager, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manager.e2c24038.svg";
export { ForwardRef as ReactComponent };